"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _History = require("../util/History");

var Canonical = function Canonical(_ref) {
  var rel = _ref.rel,
      to = _ref.to;
  return _react.default.createElement("link", {
    rel: rel,
    href: (0, _History.getFullHref)(to)
  });
};

Canonical.propTypes = {
  rel: _propTypes.default.oneOf(['canonical', 'next', 'prev']),
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired
};
Canonical.defaultProps = {
  rel: 'canonical'
};
var _default = Canonical;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Canonical.js
// module id = 256
// module chunks = 0